export default "__VITE_ASSET__DcGcrzGo__"